import React, {Component} from 'react';

import logo from './mazda.png'
import {Link, withRouter} from "react-router-dom";
import styled from 'styled-components'
import {withErrorHandler} from "../../errors/ErrorHandler";
import {connect} from "react-redux";
import Headroom from "react-headroom";
import routeHelper from "../../helpers/RouteHelper";
import {initContext} from '../../actions/context';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import IdleTimer from 'react-idle-timer';

import ICON_BACK from '../../shared/images/back.png'

const MenuBar = styled.div`
  display: flex;
  position: relative;
  flex-direction: row;
  height: 68px;
  background-color: #2B2B2A;
  padding: 5px 24px 5px 15px;
  vertical-align: middle;
    /* @media (min-width: 320px) and  (max-width: 360px){
      padding: 10px 0px 5px 5px;
    }
    @media (min-width: 361px) and (max-width: 460px){
      padding: 5px 5px 5px 5px;
    } */
    @media (max-width: 580px) {
      padding: 5px 15px 5px 15px;
    }

    a {
      position: absolute;
      left: 50%;
      top: 50%;
      -webkit-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
    }
      
    .backBtn {
      position: absolute;
      height: 30px;
      top: 15px;
      left: 15px;
      filter: invert(99%) sepia(0%) saturate(7496%) hue-rotate(234deg) brightness(104%) contrast(100%);
    }

    .backWrap {
      cursor: pointer;
      padding-right: 50px;
    }
    
    img{
      height: 40px;
      width: auto;
      @media (max-width: 1000px){
      }

  .avatar__dropdown__menu {
    text-align: right;
  }   
`;

const SpaceDiv = styled.div`
  flex: 1;
`;

const MenuBarContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0 10px;
  line-height: 28px;
`;
const MainLayoutDiv = styled.div`
   display: block;
`

class MainLayout extends Component {

  state = {
    dropdownOpen: false,
    company: null,
    timeout: 600000,
    backToggle: false
  };

  componentDidMount() {

    this.props.initPage();

    let url = this.props.location.pathname;

      if (url.includes('customer_info') || url.includes('calculator')) {
        this.setState({
          backToggle: true
        })
      }
      else {
        this.setState({
          backToggle: false
        })
      }

  }

  componentDidUpdate = (prevProps, prevState, snapshot) => {
    let url = this.props.location.pathname;

    if (prevProps.location.pathname !== url) {
      if (url.includes('customer_info') || url.includes('calculator')) {
        this.setState({
          backToggle: true
        })
      }
      else {
        this.setState({
          backToggle: false
        })
      }
    }

  }

  onBack = () => {
    let url = this.props.location.pathname;
    let array = url.split('/')
    if (array.length === 9 && this.props.location.pathname.includes('customer_info')) {
      this.props.history.push('/calculator/' + array[2] + "/" + array[3] + "/" + array[4] + "/" + array[5] + "/" + array[6] + "/" + array[7] + "/" + array[8] )
    }
    else if (array.length === 9 && this.props.location.pathname.includes('calculator')){
      this.props.history.push('/')
    }
    else {
      window.history.back();
    }
  }

  onMenuLinkClick(item) {
    if(item == "SIGN_OUT"){
       sessionStorage.removeItem('token');
       window.location.reload();
       
    }
  }

  toggle = () => {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }

  onZoneSelected(zone) {
    this.props.setZone(zone);
  }

  _onActive = ()=>{
  }
  _onIdle = ()=>{
      console.log('_onIdle');
      // this.props.history && this.props.history.push('/login');
  }

  render() {
    let company = this.props.company;
    let zoneId = this.props.context.zoneId;

    let zones = company && company.zones;

    let zone = zoneId && zones && zones.find(i => i.zoneId == zoneId);

    let mainLink = '';
    // if (sessionStorage.getItem('isApplied')) {
    //   sessionStorage.getItem('isApplied').toString() == 'true' ? mainLink = "/confirmation" : mainLink = '';
    // }
     



    const zoneLabel = <React.Fragment>

    </React.Fragment>
    return (
      <IdleTimer
       ref="idleTimer"
       element={document}
       activeAction={this._onActive}
       idleAction={this._onIdle}
       timeout={this.state.timeout}>
        <MainLayoutDiv>
          <Headroom style={{zIndex: 10}}>
            <MenuBar>
              {
                this.state.backToggle ? 
                <div className="backWrap" onClick={this.onBack}>
                  <img src={ICON_BACK} className="backBtn" alt="" />
                </div> : ''
              }
                <Link to={mainLink}>
                    <img src={logo} alt=""/>
                </Link>
                <SpaceDiv></SpaceDiv>
                <MenuBarContainer>
                </MenuBarContainer>
            </MenuBar>
          </Headroom>
          <div>
            {this.props.children}
          </div>
        </MainLayoutDiv>
      </IdleTimer>

    );
  }
}

const mapStateToProps = (state) => {
  return {
    company: state.context.company,
    context: state.context
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    initPage() {
      dispatch(initContext({history: this.history}));
    },
    setZone(zone) {
      let {location, history, match} = this;
      let {companyCode, countryCode} = this.context;
      history.push(`/${companyCode}/${countryCode}-${zone.zoneCode}/`);
    }
  }
};



export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withErrorHandler(MainLayout)));




// WEBPACK FOOTER //
// ./src/components/main-layout/MainLayout.js